import {
  ActionNode,
  ActionNodeWait,
  ActionNodeCondition,
  ActionNodeEmail,
  ActionNodeIntegration,
  ActionNodeNotification,
  ActionNodeWebhook,
  ActionNodeEndAutomation,
  ActionNodeGoto
} from '@/utils/models/node'

import {
  ActionTypes
} from '../dictionaries'

class ActionNodeFactory {
  createNode(model, type = 'simple') {
    const nodes = {
      [ActionTypes.WAIT]: ActionNodeWait,
      [ActionTypes.CONDITION]: ActionNodeCondition,
      [ActionTypes.EMAIL]: ActionNodeEmail,
      [ActionTypes.INTEGRATION]: ActionNodeIntegration,
      [ActionTypes.NOTIFICATION]: ActionNodeNotification,
      [ActionTypes.WEBHOOK]: ActionNodeWebhook,
      [ActionTypes.END_AUTOMATION]: ActionNodeEndAutomation,
      [ActionTypes.GOTO]: ActionNodeGoto,
      simple: ActionNode
    }

    const Node = nodes[type] || nodes.simple

    return new Node(model)
  }
}

export default ActionNodeFactory



// WEBPACK FOOTER //
// ./src/utils/factories/ActionNodeFactory.js